import _ from 'lodash';
import * as adapi from '~/utils/adapi';
import FormInput from '~/components/form-input/FormInput.vue';
import { setJWTToken } from '~/utils/auth';

export default {
  props: {
    platform: {
      type: String,
      required: true,
    },
  },
  components: {
    FormInput,
  },
  data() {
    return {
      loading: false,
      newPassword: null,
      newPasswordConfirm: null,
    };
  },
  computed: {
    activationCode() {
      return _.get(this.$route, 'query.code', null);
    },
  },
  methods: {
    onFinishRegistration() {
      this.loading = true;
      adapi.post('users/activate', {
        code: this.activationCode,
        password: this.newPassword,
        password_confirmation: this.newPasswordConfirm,
      })
        .then(token => {
          setJWTToken(token)
            .then(() => {
              this.loading = false;
              this.$router.push('/');
            })
            .catch(error => {
              this.loading = false;
              this.$toast.error(String(error));
            });
        })
        .catch(error => {
          this.loading = false;
          this.$toast.error({ message: String(error) });
        });
    },
  },
};




// WEBPACK FOOTER //
// ./src/gotu-vue-common/src/components/register/Register.js